import { render, staticRenderFns } from "./TrueIDCard.vue?vue&type=template&id=59c59b2a&scoped=true&"
import script from "./TrueIDCard.vue?vue&type=script&lang=ts&"
export * from "./TrueIDCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c59b2a",
  null
  
)

export default component.exports